import {createApp} from 'vue'
import HistoricFundPrices from './HistoricFundPrices'
import handleComponentProps from '../../foundation/js/utils/handleComponentProps.js'

const el = '.nyk-component--historic-fund-prices'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((HistoricFundPricesDOM) => {
            const props = handleComponentProps(HistoricFundPrices, HistoricFundPricesDOM)
            const component = createApp(HistoricFundPrices, props).use(Store)
            component.mount(HistoricFundPricesDOM)
        })
    }
}